import { type ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

const CONFIRM_STRING = 'RESET STREAKS';

type ActionsProps = {
  onCancel: () => void;
  onConfirm: () => void;
  confirmLabel: string;
  disabled?: boolean;
};

function ConfirmActions(p: ActionsProps): ReactNode {
  return (
    <div className="flex justify-end gap-sm pt-base">
      <Button variant="ghost" size="sm" onClick={p.onCancel}>
        Cancelar
      </Button>
      <Button
        variant="danger"
        size="sm"
        onClick={p.onConfirm}
        disabled={!!p.disabled}
      >
        {p.confirmLabel}
      </Button>
    </div>
  );
}

type Step1Props = {
  onContinue: () => void;
  onCancel: () => void;
};

export function Step1Content({ onContinue, onCancel }: Step1Props): ReactNode {
  return (
    <div className="space-y-base">
      <p className="text-sm text-text-secondary">
        Esto reseteará los streaks de TODOS los collectors activos y desbaneará
        a los que estaban baneados por no cumplir objetivos. Los baneados por
        strikes manuales NO se tocarán.
      </p>
      <p className="text-xs text-text-tertiary">
        Acción irreversible. Pensada para el día del lanzamiento.
      </p>
      <ConfirmActions
        onCancel={onCancel}
        onConfirm={onContinue}
        confirmLabel="Continuar"
      />
    </div>
  );
}

type Step2Props = {
  typed: string;
  setTyped: (v: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
  pending: boolean;
};

function Step2Prompt(): ReactNode {
  return (
    <p className="text-sm text-text-secondary">
      Confirma escribiendo{' '}
      <code className="rounded bg-surface-secondary px-1 font-mono text-text-primary">
        {CONFIRM_STRING}
      </code>{' '}
      para proceder.
    </p>
  );
}

export function Step2Content(p: Step2Props): ReactNode {
  const matches = p.typed === CONFIRM_STRING;
  return (
    <div className="space-y-base">
      <Step2Prompt />
      <Input
        value={p.typed}
        onChange={(e) => p.setTyped(e.target.value)}
        placeholder={CONFIRM_STRING}
        autoFocus
      />
      <ConfirmActions
        onCancel={p.onCancel}
        onConfirm={p.onConfirm}
        confirmLabel="Resetear todos"
        disabled={!matches || p.pending}
      />
    </div>
  );
}
